import { PromotionDetails } from "@/@types/Promotion";
import { PromotionDetailsResponse } from "../../promotion/models/PromotionDetailsResponse";

export function mapPromotionDetails(response: PromotionDetailsResponse): PromotionDetails {
    return {
        id: response.id,
        title: response.title,
        subtitle: response.subtitle,
        start_date: response.start_date,
        end_date: response.end_date,
        hide_date: response.hide_date,
        extra_period: response.extra_period,
        full_image: response.full_image,
        full_media: response.full_media,
        content: response.content,
        status_id: response.status_id,
        order: response.order,
        slug: response.slug,
        link: response.link,
        is_blank: response.is_blank,
        meta_title: response.meta_title,
        meta_description: response.meta_description,
        meta_keywords: response.meta_keywords,
    }
}